export default [
  'hasCarWash',
  'hasCarService',
  'hasPharmacy',
  'hasClothesStudio',
  'hasAtm',
  'hasPool',
  'hasBuffet',
  'hasExhibitionAndWarehouseComplex',
  'hasHotel',
  'hasCafe',
  'hasCinema',
  'hasConferenceRoom',
  'hasMedicalCenter',
  'hasMinimarket',
  'hasWarehouse',
  'hasNotaryOffice',
  'hasBankDepartment',
  'hasPark',
  'hasRestaurant',
  'hasBeautyShop',
  'hasCanteen',
  'hasSupermarket',
  'hasShoppingArea',
  'hasFitnessCentre',
  'hasStudio',
  'hasCentralReception',
];
